import React from 'react'
import pdfLogo from 'images/pdf-logo.png'
import LimitedViewText from './LimitedViewText'
import { getTopThree, getBottomThree } from './helper'

const Essentials = ({
  name, limitedView, malePersonaName, femalePersonaName, professions,
  topInterests, topMaleInterests, topFemaleInterests, photo
}) => {
  const content = (
    <React.Fragment>
      <p className="h2 medium text-violet-red x-lg-h1">The Essentials</p>

      <p className="persona-sub-title border-bottom border-gallery bw-2 mb3 pb2">Interests</p>

      <div className="flex flex-wrap mxn3">
        <div className="col-4 px3 sm-col-12">
          <p className="h2 x-lg-h3">
            When online, <span className="bold text-tuna">{name}</span> is most interested in {getTopThree(topInterests.map(interest => interest.name))}.
          </p>
        </div>

        <div className="col-8 px3 sm-col-12">
          <div className="flex flex-wrap fs-18 mxn2 x-lg-h4">
            <div className="col-6 mb2 px2 sm-col-12">
              {femalePersonaName} and females in general tend to be mostly interested in&nbsp;
              {
                !limitedView
                  && (
                    <span>
                      {getTopThree(topFemaleInterests.map(interest => interest.name))}
                    </span>
                  )
                  || <LimitedViewText />
              }
            </div>

            <div className="col-6 mb2 px2 sm-col-12">
              {malePersonaName} and males in general tend to be mostly interested in&nbsp;
              {
                !limitedView
                && (
                  <span>
                      {getTopThree(topMaleInterests.map(interest => interest.name))}
                    </span>
                )
                || <LimitedViewText />
              }
            </div>

            <div className="col-6 mb2 px2 sm-col-12">
              {
                !limitedView
                && (
                  <span>
                      {getTopThree(professions.map(interest => interest.name))}&nbsp;
                    </span>
                )
                || <LimitedViewText />
              }

              are the professions that are mostly interested in your category or show an interest in purchasing an item within your category.
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <section className="section" data-anchor="essentials">
        <div className="slider-box slider-box--sm-p0 slider-box--pdf-p0 bg-white box-shadow-box flex flex-wrap sm-flex-column-reverse">
          <div className="p4 sm-px0 sm-py3">
            {content}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default Essentials
